module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Diagnostics-9905518452713fd8e34ce659448501f3.svg";